module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASBAMAAABP1yhnAAAAKlBMVEVHcEz/BJT/BJT/BJT/BJT/BJT/BJT/BJT/BJT/BJT/BJT/BJT/BJT/BJRIA36hAAAADXRSTlMAzFWIu5l3ZjOqIu7djkD/gAAAAGlJREFUCNdjYGBgWKS0gAEMCu/evVgAYrDeBYKrINZcEOvuBAYG5rt3b0vfvXuZgaEXqIoRKNjAkHv37h0bICuBwfcuBDgwyAJlFYEsATCLEczyhbIcQDrArAQkUxAmI2xDcgHCVTCXAgDIc1dHNni9hAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconsv5/icon-info-endosos.png
// module id = PMlF
// module chunks = 1